// extracted by mini-css-extract-plugin
module.exports = {"paragraphInfoBlockWrapper":"Paragraph_paragraphInfoBlockWrapper_1e98F","blockTitle":"Paragraph_blockTitle_3Pz_c"};